import PropTypes from 'prop-types'

import { GenericCarousel } from 'reactGarden/GenericCarousel'

import { CategoryItem } from './components/CategoryItem'

const CategoryCarousel = ({ items, onItemClick }) => (
  <GenericCarousel
    spaceBetween={15}
    slidesPerView="auto"
    centerInsufficientSlides
  >
    {items.map(item => (
      <div key={item.id}>
        <CategoryItem item={item} onClick={onItemClick} />
      </div>
    ))}
  </GenericCarousel>
)

CategoryCarousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  onItemClick: PropTypes.func
}

export default CategoryCarousel
